export default (mode, changeMode, width = 33, height = 33) => ({
    icon: mode === "password" ? "eye" : "eye-slash",
    elementAttr: {
        class: "no-border animate-hover-color p-0"
    },
    onClick: changeMode,
    width,
    height
});
